export class PublicTokenExchangeRequest{
    public userId!:string;
    public publicToken!:string;
}